import Cell from "../WaveFunctionCollapseV2/Cell.ts";
import { Vector3 } from "three";
import { Edges } from "@react-three/drei";
import Tile from "./Tile.tsx";
import PrototypeManager from "../WaveFunctionCollapseV2/Prototype/PrototypeManager.ts";
import PrototypeImpl from "../PrototypeImpl.ts";
import EmptyCell from "./Cells/EmptyCell.tsx";

interface WorldProps {
  gridMap: Cell[][][];
  cellSize: number;
  prototypeManager: PrototypeManager;
  showEmptyCells: boolean;
}

export default function World({
  gridMap,
  cellSize,
  prototypeManager,
  showEmptyCells,
}: WorldProps): JSX.Element {
  const gridMapCoordinatesTo3DWorldCoordinates = (
    x: number,
    y: number,
    z: number,
  ): Vector3 => {
    const offset = cellSize / 2; // TODO : fix this, this is to center the pieces to its corner on 0,0
    return new Vector3(
      x * cellSize - offset,
      y * cellSize + offset,
      z * cellSize - offset,
    );
  };

  return (
    <>
      {gridMap.map((x, xIndex) => {
        return x.map((y, yIndex) => {
          return y.map((z, zIndex) => {
            const cell = z;
            const coordinates = gridMapCoordinatesTo3DWorldCoordinates(
              xIndex,
              yIndex,
              zIndex,
            );

            if (cell.collapsed && cell.collapsedCellPrototypeId) {
              return (
                <Tile
                  key={`${xIndex}-${yIndex}-${zIndex}`}
                  tilePosition={coordinates}
                  tileSize={cellSize}
                  prototype={
                    prototypeManager.getPrototypeById(
                      cell.collapsedCellPrototypeId,
                    ) as PrototypeImpl
                  }
                />
              );
            } else {
              return showEmptyCells ? (
                <EmptyCell
                  cell={cell}
                  cellSize={cellSize}
                  key={`${xIndex}-${yIndex}-${zIndex}`}
                  position={coordinates}
                  onClick={(event) => {
                    console.log(
                      "clicked empty cell",
                      cell.possiblePrototypesIds.map((id) =>
                        prototypeManager.getPrototypeById(id),
                      ),
                      cell.coordinates,
                    );
                    event.stopPropagation();
                  }}
                />
              ) : null;
            }
          });
        });
      })}
    </>
  );
}
